export const userColumns = [
 
    {
      field: "roomTypeCode",
      headerName: "Room Code",
      width: 200,
    },
    {
      field: "roomTypeName",
      headerName: "Room Name",
      width: 150,
    },
    {
      field: "activeStatus",
      headerName: "Active Status",
      width: 150,
    },
    {
        field: "description",
        headerName: "Description",
        width: 150,
      },
   
  ];